// Grupos estilo WhatsApp (Victor 2026-06-05 · P4). En los grupos de WhatsApp el
// bridge antepone al contenido la línea del participante:
//   "👥 *Nombre (123456@lid)*\n\n<mensaje real>"
// Aquí parseamos esa línea para mostrar avatar + nombre A COLOR (color fijo por
// persona, como WhatsApp) + etiqueta Cliente/Agente, y quitar el "(…@lid)".

// Paleta fija estilo WhatsApp. El índice sale de un hash del identificador, así la
// MISMA persona siempre tiene el MISMO color en todos los grupos.
const GROUP_PALETTE = [
  '#E57373', // rojo
  '#64B5F6', // azul
  '#FFD54F', // amarillo
  '#81C784', // verde
  '#BA68C8', // morado
  '#4DB6AC', // teal
  '#FF8A65', // naranja
  '#F06292', // rosa
  '#9575CD', // morado oscuro
  '#4FC3F7', // celeste
  '#AED581', // verde claro
  '#A1887F', // marrón
];

// "👥 *Nombre (id)*\n\n" — id puede ser 123@lid, 123@s.whatsapp.net o solo dígitos.
const GROUP_PREFIX_RE = /^👥\s*\*(.+?)\s*\(([^)]+)\)\*\s*\n*/;

const hashString = str => {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};

const firstName = name =>
  String(name || '')
    .replace(/[^\p{L}\s]/gu, '')
    .trim()
    .split(/\s+/)[0]
    ?.toLowerCase() || '';

// Best-effort: si el primer nombre del participante coincide con el primer nombre
// de algún agente del equipo → "Agente"; si no → "Cliente".
const roleFor = (name, agentNames) => {
  const fn = firstName(name);
  if (fn && agentNames.has(fn)) return 'Agente';
  return 'Cliente';
};

export const buildAgentFirstNames = (agents = []) =>
  new Set((agents || []).map(a => firstName(a?.name)).filter(Boolean));

export const parseGroupSender = (content, agentNames = new Set()) => {
  const c = String(content || '');
  const m = c.match(GROUP_PREFIX_RE);
  if (!m) return null;

  const name = m[1].trim();
  const id = m[2].trim();
  const color = GROUP_PALETTE[hashString(id || name) % GROUP_PALETTE.length];

  return {
    name,
    id,
    color,
    role: roleFor(name, agentNames),
    cleanContent: c.replace(GROUP_PREFIX_RE, ''),
  };
};
